import { render, staticRenderFns } from "./calculator-input.vue?vue&type=template&id=5b00675c&scoped=true"
import script from "./calculator-input.vue?vue&type=script&lang=js"
export * from "./calculator-input.vue?vue&type=script&lang=js"
import style0 from "./calculator-input.vue?vue&type=style&index=0&id=5b00675c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00675c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HLabel: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/forms/h-label.vue').default})
